import { resolveOnboardingDebugState } from '~/utils/onboarding/onboardingDebug';

/**
 * Onboarding modal preview via URL query params.
 * Active in local dev and on Contentful preview stages
 * (`runtimeConfig.public.isPreviewEnabled`).
 *
 * Example:
 * `?onboardingDebug=1&onboardingStep=industry&onboardingName=Jane&onboardingWelcomeVariant=returningIncomplete`
 */
export function useOnboardingDebug() {
  const route = useRoute();
  const {
    public: { isPreviewEnabled }
  } = useRuntimeConfig();

  const debugState = computed(() =>
    resolveOnboardingDebugState(
      route.query as Record<string, unknown>,
      import.meta.dev || isPreviewEnabled
    )
  );

  const isOnboardingDebugActive = computed(() => debugState.value.isActive);
  const debugInitialStep = computed(() => debugState.value.initialStep);
  const debugWelcomeName = computed(() => debugState.value.welcomeName);
  const debugWelcomeCompany = computed(() => debugState.value.welcomeCompany);
  const debugWelcomeVariant = computed(() => debugState.value.welcomeVariant);

  return {
    isOnboardingDebugActive,
    debugInitialStep,
    debugWelcomeName,
    debugWelcomeCompany,
    debugWelcomeVariant
  };
}

export { ONBOARDING_DEBUG_WELCOME_DEFAULTS } from '~/utils/onboarding/onboardingDebug';
